<template lang="pug">
  .sand-box
    //- img(src="https://summit-img.geekpark.net//frontier01_1.jpg")
    //- a(@click="trackOutboundLink()" @tap="trackOutboundLink()")
    //-   img(src="https://summit-img.geekpark.net//frontier02_1.jpg")
    //- img(src="https://summit-img.geekpark.net//frontier03_1.jpg")
    //- img(src="https://summit-img.geekpark.net//frontier05_1.jpg" style="border-top: 1px solid #c9c7c6")
    //- a(@click="trackOutboundLink()" @tap="trackOutboundLink()")
    //-   img(src="https://summit-img.geekpark.net//frontierLark20200227-152816.png" class="link")
    img(src="https://summit-img.geekpark.net/frontier/img/ffounder-mobile-1-1.png")
</template>

<script>
  export default {
    name: "Sandbox",
    created() {
      document.title = '「未来前沿」创始人工坊'
    },
    mounted() {
      document.querySelector('#app').style.padding = '0px'
    },
    updated() {
      document.querySelector('#app').style.padding = '0px'
    },
    destroyed() {
      document.title = 'The Frontier 前沿社 - 开启认知新可能'
    },
    methods: {
      trackOutboundLink() {
        gtag('event', '点击报名', {'dimension_name': '网页点击'});
        setTimeout(function () {
          document.location = 'http://e1uvvwi0z6iwtvsh.mikecrm.com/tFYAQNH';
        }, 200)
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .sand-box
    max-width 500px
    width 100vw
    height 100vh
    margin auto
    overflow auto

    a
      display block
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    img
      width 100%
      outline-width 0px
      vertical-align top
      position relative


    .link
      width 25vw
      position fixed
      bottom 3vw
      right 3vw
</style>



// WEBPACK FOOTER //
// Sandbox.vue?5a450e7e